import { render, staticRenderFns } from "./ProdutoTabs.vue?vue&type=template&id=eedee6ce"
import script from "./ProdutoTabs.vue?vue&type=script&lang=js"
export * from "./ProdutoTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports